/**
 * 统一管理 ·登录后订阅的全局数据·
 * - 登录后: 登录后,调用 reSub,重新订阅
 * - 断开重连：清空数据，重新订阅
 * - 退出登录：清空所有订阅，数据
 *
 */
import front from '@/../static/js/proto/CtpFront';
import * as utils from '@/utils/utils';
import store from './index';
import subFuns from './sub-utils/subfuns';
import unSubFuns from './sub-utils/unsubfuns';
/**
 * 是否订阅的接口
 */
interface ISub {
  params: any[];
  isSub: boolean;
}

/**
 * 缓存订阅
 */
let cache: { [key: string]: ISub } = {};
/**
 * 订阅
 * 假如没有登录，则放到缓存列表中，登录后再订阅
 * @param name 订阅的名字
 * @param params 订阅的数组
 */
export function sub(name, params) {
  // 已经订阅，直接返回
  if (cache[name]) {
    return;
  }
  // 已登录，则直接订阅
  if (front.user) {
    // 记录订阅
    cache[name] = {
      params,
      isSub: true,
    };
    // 订阅
    subFuns[name](params);
    console.log('sub ' + name);
    return;
  }
  // 未登录，则放到缓存数组中，统一订阅
  cache[name] = {
    params,
    isSub: false,
  };
}

/**
 * 登录成功后，重新订阅没有订阅成功的
 */
export function reSub() {
  for (const key in cache) {
    if (cache.hasOwnProperty(key)) {
      if (!cache[key].isSub) {
        cache[key].isSub = true;
        const params = cache[key].params;
        console.log('sub ' + key);
        subFuns[key](params);
      }
    }
  }
}

/**
 * 退出登录时，清空所有数据，以及订阅
 */
export function clearAll() {
  for (const key in cache) {
    if (cache.hasOwnProperty(key)) {
      if (unSubFuns[key]) {
        unSubFuns[key](cache[key].params);
      }
    }
  }
  cache = {};
  store.commit('Params/clearAll');
}
/**
 * 断开重连后，重新订阅
 */
front.regReconnect(() => {
  // 清空所有数据
  for (const key in cache) {
    if (cache.hasOwnProperty(key)) {
      if (unSubFuns[key]) {
        unSubFuns[key](cache[key].params);
      }
      cache[key].isSub = false;
    }
  }
  // 重新订阅
  reSub();
});
/**
 * 取消订阅
 */
export function unSub(name) {
  if (unSubFuns[name]) {
    unSubFuns[name](cache[name].params);
  }
  delete cache[name];
}



// WEBPACK FOOTER //
// ./src/store/SubUtils.ts